export default __webpack_public_path__ + "static/media/clock.7ca25afc.svg";